import { Component, OnInit, Input } from "@angular/core";
import { LanguageService } from "src/app/shared/services/language/language.service";
import { Subject } from "rxjs";
import { AlertService } from "../../shared/services/alert/alert.service";
import { first } from "rxjs/operators";

@Component({
  selector: "app-portal-language",
  templateUrl: "./portal-language.component.html",
  styleUrls: ["./portal-language.component.scss"]
})
export class PortalLanguageComponent implements OnInit {
  selectedOption: any;
  private _success = new Subject<string>();
  private _error = new Subject<string>();
  @Input() tab: any;
  //alerts
  errorMessage = null;
  successMessage = null;

  sender = "portal-language";
  opts = [
    { name: "Only English", value: "english" },
    { name: "Only Regional", value: "regional" },
    { name: "Bi-Lingual: Both", value: "bilingualboth" },
    { name: "Bi-Lingual: Switch", value: "bilingualswitch" }
  ];

  actions = [
    {
      icon: "fas fa-angle-double-right",
      class: "btn btn-primary",
      type: "SELECT_ALL"
    },
    { icon: "fas fa-angle-right", class: "btn btn-info", type: "SELECT_ONE" },
    { icon: "fas fa-angle-left", class: "btn btn-info", type: "REMOVE_ONE" },
    {
      icon: "fas fa-angle-double-left",
      class: "btn btn-danger",
      type: "REMOVE_ALL"
    }
  ];

  languages: any;
  portalLanguages: any;
  error: string;

  constructor(
    private languageService: LanguageService,
    private alertService: AlertService
  ) {}

  ngOnInit() {
    this.selectedOption = this.opts[0];
    this.loadAvailableLangs();
    this.languageService
      .getLangPreference()
      .pipe(first())
      .subscribe(res => {
        if (res["language"]) {
          for (var i = 0; i < this.opts.length; i++) {
            if (this.opts[i].value == res["language"]) {
              this.selectedOption = this.opts[i];
              break;
            }
          }
        }
      });
  }

  loadPortalLanguages() {
    this.languageService
      .getPortalLanguages()
      .pipe(first())
      .subscribe(res => {
        this.portalLanguages = res;

        if (this.portalLanguages && this.languages) {
          for (var i = 0; i < this.languages.length; i++) {
            for (var j = 0; j < this.portalLanguages.length; j++) {
              if (this.portalLanguages[j]._id === this.languages[i]._id) {
                this.languages[i].selected = true;

                break;
              }
            }
          }
        }
        //now match with the languages.
      });
  }

  loadAvailableLangs() {
    this.languageService
      .getLanguage()
      .pipe(first())
      .subscribe(res => {
        this.languages = res;
        this.loadPortalLanguages();
      });
  }

  onLangPrefClick(lang) {
    this.languageService
      .saveLangPreference(lang.value)
      .pipe(first())
      .subscribe(res => {
        this.selectedOption = lang;
        this.ensureEnglish();
      });
  }

  saveLangPref() {
    var langs = [];

    for (var i = 0; i < this.languages.length; i++) {
      if (this.languages[i].selected) {
        langs.push(this.languages[i].code);
      }
    }

    

    this.languageService
      .addPortalLanguage(langs)
      .pipe(first())
      .subscribe(res => {
          this.alertService.show(this.sender, "Languages updated sucessfully");
      });
  }

  selectAll() {
    var numChanges = 0 ;
    for (var i = 0; i < this.languages.length; i++) {
      if (!this.languages[i].selected){
        numChanges ++;
      }
      this.languages[i].selected = true;
      this.languages[i].leftSelected = false;
      this.languages[i].rightSelected = false;
    }
    return numChanges > 0;
  }

  removeAll() {

    var numChanges = 0 ;

    for (var i = 0; i < this.languages.length; i++) {
      if (this.languages[i].selected){
        numChanges ++;
      }
      this.languages[i].selected = false;
      this.languages[i].leftSelected = false;
      this.languages[i].rightSelected = false;
    }
    return numChanges > 0;
  }

  selectOne() {
    var changes = 0 ;
    for (var i = 0; i < this.languages.length; i++) {
      if (this.languages[i].leftSelected) {
        this.languages[i].selected = true;
        this.languages[i].leftSelected = false;
        changes ++;
      }
    }

    return changes > 0 ;
  }

  removeOne() {
    var changes = 0 ;
    for (var i = 0; i < this.languages.length; i++) {
      if (this.languages[i].rightSelected) {
        changes ++;
        this.languages[i].selected = false;
        this.languages[i].rightSelected = false;
      }
    }

    return changes > 0 ;
  }

  onAction(action) {
    var result = false;
    if (action.type == "SELECT_ALL") {
      result =  this.selectAll();
    } else if (action.type == "SELECT_ONE") {
      result =  this.selectOne();
    } else if (action.type == "REMOVE_ONE") {
      result = this.removeOne();
    } else if (action.type == "REMOVE_ALL") {
      result = this.removeAll();
    }

    if (result){
     
      this.saveLangPref();
    }
  }

  onLeftLangClick(l) {
    l.leftSelected = !l.leftSelected;
  }

  onRightLangClick(l) {
    l.rightSelected = !l.rightSelected;
  }

  ensureEnglish() {
    if (!this.selectedOption) {
      return;
    }

    if (this.selectedOption.value == "regional") {
      return;
    }

    if (this.selectedOption.value == "english") {
      this.languageService
        .addPortalLanguage(["english"])
        .pipe(first())
        .subscribe(res => {});
    }
  }
}
